import { ConfiguratorItem } from '../configurator-item';
import { Configuration } from '../../../../models/configurators-2d/applications/carpentry/configuration';
import { CarpentryService } from '../../../../services/configurators-2d/applications/carpentry.service';

export abstract class CarpentryConfiguratorItem extends ConfiguratorItem<Configuration, CarpentryService> {
  constructor(carpentryService: CarpentryService) {
    super(carpentryService);
  }
}
